<template>
  <div
    :style="{
      display: hasDescription ? '' : 'none',
    }"
  >
    <template v-if="hasDescription">
      <template v-if="opened">
        <m-description ref="description" class="show-description-modal" @close="onClose" />
      </template>
      <a v-if="type === 'mini'" href="javascript:void(0)" class="show-description-link show-description-link--mini" @click="showDescription"> 
        <svg class="show-description-link-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="9" stroke="#8E9CBB" stroke-width="2" fill="none"/>
          <path d="M11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6Z" fill="#8E9CBB"/>
          <path d="M9 14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14Z" fill="#8E9CBB"/>
        </svg>
        <span class="show-description-link-text">Показать описание</span>
      </a>
      <a v-else href="javascript:void(0)" class="show-description-link" @click="showDescription">Показать описание</a>
    </template>
  </div>
</template>

<script>
import MDescription from "@/components/modals/description-modal";

export default {
  components: { MDescription },
  props: ["value", "list", "type"],

  data() {
    return {
      opened: false,
    };
  },
  computed: {
    dictionary() {
      const dict = {};
      (this.list || []).forEach((item) => {
        dict[item.id] = item;
      });
      return dict;
    },
    model() {
      if (!this.value) return null;
      if (typeof this.value === "object" && "hasDescription" in this.value) return this.value;
      return this.dictionary[this.value];
    },
    hasDescription() {
      return this.model && this.model.hasDescription;
    },
  },

  methods: {
    showDescription() {
      if (this.model && this.model.hasDescription) {
        this.open();
      }
    },
    open() {
      this.opened = true;
      this.$nextTick(() => {
        this.$refs.description.open(this.model);
      });
    },
    onClose() {
      this.opened = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.show-description {
  &-link {
    font-size: 13px;
    font-weight: 500;
    color: $color-primary;
    cursor: pointer;

    &--mini {
      .show-description-link-text {
        display: none;
      }

      @include vp-767 {
        .show-description-link-text {
          display: inline;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
